import React, { Component } from "react";
import * as PropTypes from "prop-types";
import ChallengeDialog from "../../common/components/ChallengeDialog";
// import gql from "graphql-tag"; // TODO: Replaced with REST hook
// import { SecureQuery } from "../../settings/graphqlHelper"; // TODO: Replaced with REST hook
import CircularCountDown from "../../common/components/base/CircularCountDown";
// import { evaluateStep } from "../challenges/AdServer/simulation"; // TODO: Replaced with REST hook
// import { client } from "../../settings/apollo"; // TODO: Replaced with REST hook
import { useDeleteChallenge } from "../../hooks/useDeleteChallenge";
import { useFinishChallenge } from "../../hooks/useFinishChallenge";
import { useEvaluateStep } from "../../hooks/useEvaluateStep";
import ChallengeContext from '../../store/challenge-context';
import RouterPropsWrapper from "../../common/RouterPropsWrapper";

// TODO: Replaced with REST hook
// const DELETE_CHALLENGE = gql`
//   mutation deleteChallenge($input: String) {
//     deleteChallenge(input: $input)
//   }
// `;

// const FINISH_CHALLENGE = gql`
//   mutation finishChallenge($id: String) {
//     finishChallenge(id: $id)
//   }
// `;

// Wrapper component to use hooks with class component
const ChallengePanelWrapper = (props) => {
  const deleteChallengeMutation = useDeleteChallenge();
  const finishChallengeMutation = useFinishChallenge();
  const evaluateStepMutation = useEvaluateStep();

  return (
    <ChallengePanelClass
      {...props}
      deleteChallengeMutation={deleteChallengeMutation}
      finishChallengeMutation={finishChallengeMutation}
      evaluateStepMutation={evaluateStepMutation}
    />
  );
};

class ChallengePanelClass extends Component {
  static contextType = ChallengeContext;

  constructor(props) {
    super(props);
    this.state = { ...props, open: false, key: 0 };
    this.handleExit = this.handleExit.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
    this.handleSkip = this.handleSkip.bind(this);
    this.timerReset = React.createRef();
    this.timerSet = React.createRef();
    this.timerStart = React.createRef();
  }

  resetTimer(reset) {
    reset();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.step !== this.props.step)
      this.setState({key: this.state.key+1})
  }

  handleExit = async () => {
    var id;
    if (window.location.pathname.split("/").pop()) {
      id = window.location.pathname.split("/").pop();
      if (
        window.confirm(
          "Are you sure you want to exit the Challenge? Your record won’t be saved and you will need to retake the challenge"
        )
      ) {
        try {
          await this.props.deleteChallengeMutation.mutateAsync(id);
          if (this.context.challengeOrigineRoute) {
            this.props.history.push(this.context.challengeOrigineRoute);
          } else {
            this.props.history.goBack()
          }
        } catch (error) {
          console.error('Error deleting challenge:', error);
        }
      }
    } else {
      this.setState({ open: false });
    }
  };

  handleSkip = async () => {
    var id;
    const action = {
      actionNeeded: "click",
      target: "button",
      parameter: "skip",
      validationField: "skip"
    };
    if (window.location.pathname.split("/").pop()) {
      id = window.location.pathname.split("/").pop();
      if (
        window.confirm(
          "Are you sure you want to SKIP the step of the Challenge? Your score will be 0"
        )
      ) {
        try {
          const res = await this.props.evaluateStepMutation.mutateAsync({
            challengeId: id,
            action,
            challengeToDo: null
          });
          const targetUrl = `${res.challengeStepEvaluator.targetLocation}${id}`;
          window.location.assign(targetUrl);
        } catch (error) {
          console.error('Error skipping step:', error);
        }
      }
    } else {
      this.setState({ open: false });
    }
  };

  handleFinish = async () => {
    var id;
    if (window.location.pathname.split("/").pop()) {
      id = window.location.pathname.split("/").pop();
      if (
        window.confirm(
          "Are you sure you want to FINISH the Challenge? Your progress will be saved only until this step and so it will be your scoring"
        )
      ) {
        try {
          await this.props.finishChallengeMutation.mutateAsync(id);
          this.props.history.push("/challenge/end/" + id);
        } catch (error) {
          console.error('Error finishing challenge:', error);
        }
      }
    } else {
      this.setState({ open: false });
    }
  };

  render() {
    return (
      <div id="Timer">
        <div className="pb-1 mt-2 px-3">
          <CircularCountDown time={this.props.time} step={this.state.key} />
        </div>
        <div>
          <ChallengeDialog
            //title="Info Challenge"
            handleExit={this.handleExit}
            handleFinish={this.handleFinish}
            handleSkip={this.handleSkip}
            undoName="Resume"
            step={this.props.step}
            brief={this.props.description}
            coach={this.props.coach}
            challengeTitle={this.props.challengeTitle}
            challengeIsValidation={this.props.challengeIsValidation}
            challengeDifficulty={this.props.challengeDifficulty}
            challengeAverageTime={this.props.challengeAverageTime}
          />
        </div>
      </div>
    );
  }
}

ChallengePanelWrapper.propTypes = {
  time: PropTypes.any,
  description: PropTypes.any,
  handleEnd: PropTypes.any,
  coach: PropTypes.any,
  challengeTitle: PropTypes.any,
  challengeIsValidation: PropTypes.any,
  challengeDifficulty: PropTypes.any,
  challengeAverageTime: PropTypes.any,
};

export default RouterPropsWrapper(ChallengePanelWrapper);
